module.exports = __webpack_public_path__ + "media/images/preview_training_1_thumb-ab572f3595101fe0e3a0c4f94f209a77.webp";